"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const OverclaimHeaderDescription = (props) => (react_1.default.createElement(react_1.default.Fragment, null,
    !props.amendingShares ? (react_1.default.createElement("p", null, "The Overclaims Tool enables Members to see works they have registered that are in overclaim. Overclaims occur when the total shares submitted by Members for a work add up to more than 100%. Members can also use the Overclaims Tool to send an email to all Members claiming shares of a work so that all claimants can work together to resolve the overclaim.")) : (react_1.default.createElement("p", null, `To amend your shares on the work, edit the percentage in the 
                        "Collection Share" field below for the appropriate name, 
                        then click the "Submit" button at the bottom of the page.`)),
    react_1.default.createElement("p", null,
        "Click",
        ' ',
        react_1.default.createElement("a", { target: '_blank', href: 'https://help.themlc.com/en/support/what-is-an-overclaim-and-how-do-i-resolve-one-using-the-overclaims-tool', rel: "noreferrer" }, "here"),
        ' ',
        "for our Help Center article detailing options to resolve an overclaim.")));
exports.default = OverclaimHeaderDescription;
